import { useMemo } from "react";

import { Box, BoxProps } from "@aircall/tractor";

import {
  PickerProps,
  TranscriptionItemSentimentProps,
} from "./TranscriptionItemSentiment.decl";

import NegativeSvg from "@/assets/negative.svg?react";
import PositiveSvg from "@/assets/positive.svg?react";

function IconPicker({ sentiment }: PickerProps) {
  switch (sentiment) {
    case "POSITIVE":
      return <PositiveSvg />;
    case "NEGATIVE":
      return <NegativeSvg />;
    default:
      return null;
  }
}

function borderColorPicker({
  sentiment,
}: TranscriptionItemSentimentProps): BoxProps["borderColor"] {
  switch (sentiment) {
    case "POSITIVE":
      return "success-700";
    case "NEGATIVE":
      return "critical-700";
    default:
      break;
  }
}

export function TranscriptionItemSentiment({
  sentiment,
}: TranscriptionItemSentimentProps) {
  const borderColor = useMemo(
    () => borderColorPicker({ sentiment }),
    [sentiment]
  );

  if (!sentiment || sentiment === "NEUTRAL") {
    return null;
  }

  return (
    <Box
      px="8px"
      py="4px"
      borderColor={borderColor}
      borderWidth="1px"
      borderStyle="solid"
      borderRadius="24px"
      h="fit-content"
      data-test={
        sentiment === "POSITIVE"
          ? "positive_sentiment_item"
          : "negative_sentiment_item"
      }
    >
      <IconPicker sentiment={sentiment} />
    </Box>
  );
}
